export default __webpack_public_path__ + "static/media/mje_hover.bafbc26f.png";